import areEventDetailsFetched from '../selectors/areEventDetailsFetched';
import { convertToCalendarEvent } from '../utils/calendarEventUtils';
import fetchCalendarEventDetails from '../actions/fetchCalendarEventDetails';
import { getPublishedCalendarItem } from 'owa-publishedcalendar-service';
import { getPublishedFolderPath } from 'owa-publishedcalendar-settings';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import { orchestrator } from 'satcheljs';
import setCalendarEventDetails from '../actions/setCalendarEventDetails';

/**
 * Orchestrator to fetch and update calendar event details
 */
export default orchestrator(fetchCalendarEventDetails, async actionMessage => {
    const { event, fetchSeriesMaster } = actionMessage;

    if (areEventDetailsFetched(event, fetchSeriesMaster)) {
        return;
    }

    setCalendarEventDetails(convertToCalendarEvent(event), false /*eventDetailsFetched*/);

    const response = await getPublishedCalendarItem(
        event.ItemId.Id,
        fetchSeriesMaster,
        getPublishedFolderPath()
    );

    const { Body } = response;
    const { ResponseMessages } = Body;
    const { Items } = ResponseMessages;

    if (Items && Items.length > 0 && Items[0].ResponseClass == 'Success') {
        const responseItem = Items[0] as ItemInfoResponseMessage;
        let updatedEvent = convertToCalendarEvent(responseItem.Items[0]);
        setCalendarEventDetails(updatedEvent, true /*eventDetailsFetched*/);
    } else {
        // TODO: VSO.59366 - error handling and logging
    }
});
